import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom'

import { fetchCustomers } from '../store/actions/customers';
import CustomerList from '../components/customerList';
import { withLoadingComponent, withErrorComponent } from '../components/loading';

const mapStateToProps = (state) => {
    return {
        ...state.customers,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchCustomers: () => dispatch(fetchCustomers())
    }
};

const lifecycleValue = {
    componentWillMount() {
        this.props.fetchCustomers();
    }
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle(lifecycleValue),
    withErrorComponent,
    withLoadingComponent
)(CustomerList);



// WEBPACK FOOTER //
// ./src/containers/CustomersContainer.js